import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  CardContent,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from "@mui/material";
import TableHead from "@mui/material/TableHead";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import { getAssignments } from "../../adapter/assignmentAdapter";
import GoBack from "../../components/GoBack";
import Loader from "../../components/Loader";
import { baseUrlForAssignments } from "../../variables/variables";

export default function SingleAssignment() {
  const navigationData = useLocation();
  const [loading, setloading] = useState(false);
  const [responseData, setresponseData] = useState(useLocation().state);
  const handleButtonClick = async (assignmentId, batchId) => {
    try {
      const response = getAssignments(assignmentId);
      response.then((response) => {
        const byteCharacters = atob(response.fileData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${batchId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
    } catch (error) {
      console.error("Error fetching or downloading PDF:", error);
    }
  };

  useEffect(() => {
    setloading(true);
    axios
      .get(baseUrlForAssignments + `/${navigationData.state.assignmentId}`)
      .then((response) => {
        if (response.status === 200) {
          setresponseData(response.data);
          setloading(false);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data.message);
        setloading(false);
      });
  }, []);

  return (
    <div className="container">
      <ToastContainer />
      <Loader loading={loading} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 className="component-title">Assign Arbitrator</h2>
        <GoBack />
      </div>

      <div>
        <div variant="outlined" className="custom-card">
          <CardContent>
            <div className="card-header">
              <div className="card-sub-header">
                <p>
                  <h4 style={{ display: "inline" }}>
                    Batch Id : {responseData.batchId}{" "}
                  </h4>
                  &nbsp;{" "}
                  <Chip
                    variant="outlined"
                    size="small"
                    label={responseData.status}
                    color={
                      responseData.status === "ASSIGNED" ? "info" : "secondary"
                    }
                  />
                  &nbsp;{" "}
                  <span className="sub-text" style={{ fontSize: "small" }}>
                    {`Created by ${responseData.userId}`}{" "}
                  </span>
                </p>
                <Tooltip
                  title="Download"
                  onClick={() => {
                    handleButtonClick(
                      responseData.assignmentId,
                      responseData.batchId
                    );
                  }}
                  sx={{ color: "rgb(0, 81, 134)" }}
                >
                  <FileDownloadIcon />
                </Tooltip>
              </div>
            </div>
            <TableContainer
              component={Paper}
              className="custom-table-container"
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell>Batch Id</TableCell>
                    <TableCell>
                      <span className="sub-text">{responseData.batchId}</span>
                    </TableCell>
                    <TableCell className="column-border">
                      Enterprise Name
                    </TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.enterpriseName}
                      </span>
                    </TableCell>
                    <TableCell className="column-border">
                      Nature of Dispute
                    </TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.natureOfDispute}
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>No. of Cases</TableCell>
                    <TableCell>
                      <span className="sub-text">{responseData.noOfCases}</span>
                    </TableCell>{" "}
                    <TableCell className="column-border">Complexity</TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.complexity}
                      </span>
                    </TableCell>
                    <TableCell className="column-border">
                      Average Claim Value
                    </TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {`${responseData.maxClaimValue}`}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </div>
        <div>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Sr No.</TableCell>
                  <TableCell align="center">Arbitrator Id</TableCell>
                  <TableCell align="center">Cases To Be Assigned</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {responseData?.data?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row" align="center">
                      {index + 1}
                    </TableCell>
                    <TableCell align="center">{row.pseudonym}</TableCell>
                    <TableCell align="center">{row.casesAssigned}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}
